import React, { useState } from 'react';
import { X, Trash, MapPin, Plus, PencilSimple } from '@phosphor-icons/react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import AddressAutocomplete from '../AddressAutocomplete';

export const NoteModal = ({ noteForm, setNoteForm, onClose, onSubmit }) => (
  <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
    <div style={{ backgroundColor: 'white', borderRadius: '8px', width: '400px' }}>
      <div style={{ padding: '16px 20px', borderBottom: '1px solid #E2E2E6', display: 'flex', justifyContent: 'space-between' }}>
        <h3 style={{ margin: 0 }}>Ajouter une note</h3>
        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer' }}><X size={20} /></button>
      </div>
      <form onSubmit={onSubmit} style={{ padding: '20px' }}>
        <div className="form-group"><label className="form-label">Date</label><input type="date" className="form-input" value={noteForm.date} onChange={(e) => setNoteForm({...noteForm, date: e.target.value})} required /></div>
        <div className="form-group"><label className="form-label">Contenu *</label><textarea className="form-input" rows={3} value={noteForm.content} onChange={(e) => setNoteForm({...noteForm, content: e.target.value})} required placeholder="Votre note..." /></div>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button type="button" className="btn btn-secondary" onClick={onClose} style={{ flex: 1 }}>Annuler</button>
          <button type="submit" className="btn btn-primary" style={{ flex: 1 }} data-testid="submit-note">Ajouter</button>
        </div>
      </form>
    </div>
  </div>
);

export const TaskReminderModal = ({ taskForm, setTaskForm, onClose, onSubmit }) => (
  <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
    <div style={{ backgroundColor: 'white', borderRadius: '8px', width: '440px' }}>
      <div style={{ padding: '16px 20px', borderBottom: '1px solid #E2E2E6', display: 'flex', justifyContent: 'space-between' }}>
        <h3 style={{ margin: 0 }}>Nouvelle tache / rappel</h3>
        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer' }}><X size={20} /></button>
      </div>
      <form onSubmit={onSubmit} style={{ padding: '20px' }}>
        <div className="form-group"><label className="form-label">Titre *</label><input type="text" className="form-input" value={taskForm.title} onChange={(e) => setTaskForm({...taskForm, title: e.target.value})} required /></div>
        <div className="form-group"><label className="form-label">Description</label><textarea className="form-input" rows={2} value={taskForm.description} onChange={(e) => setTaskForm({...taskForm, description: e.target.value})} /></div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
          <div className="form-group"><label className="form-label">Date *</label><input type="date" className="form-input" value={taskForm.date} onChange={(e) => setTaskForm({...taskForm, date: e.target.value})} required /></div>
          <div className="form-group"><label className="form-label">Heure</label><input type="time" className="form-input" value={taskForm.time} onChange={(e) => setTaskForm({...taskForm, time: e.target.value})} /></div>
        </div>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px', fontSize: '0.9rem', cursor: 'pointer' }}>
          <input type="checkbox" checked={taskForm.reminder} onChange={(e) => setTaskForm({...taskForm, reminder: e.target.checked})} style={{ width: '18px', height: '18px' }} />
          Envoyer une notification de rappel
        </label>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button type="button" className="btn btn-secondary" onClick={onClose} style={{ flex: 1 }}>Annuler</button>
          <button type="submit" className="btn btn-primary" style={{ flex: 1 }} data-testid="submit-task-reminder">Creer</button>
        </div>
      </form>
    </div>
  </div>
);

export const PlanningTaskModal = ({ editTask, formData, setFormData, employees, projects, onClose, onSubmit, onDelete, onDeleteSeries }) => {
  const isProjectTitle = projects.some(p => p.name === formData.title);
  const [freeTextMode, setFreeTextMode] = useState(!isProjectTitle && !!formData.title);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const hasSeries = !!(editTask && editTask.recurrence_group);

  const handleSelectTitle = (v) => {
    if (v === '__custom__') {
      setFreeTextMode(true);
      setFormData({ ...formData, title: '' });
    } else {
      setFreeTextMode(false);
      const project = projects.find(p => p.name === v);
      setFormData({ ...formData, title: v, address: project?.address || formData.address });
    }
  };

  return (
  <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
    <div style={{ backgroundColor: 'white', borderRadius: '4px', width: '100%', maxWidth: '520px', maxHeight: '90vh', overflow: 'auto' }}>
      <div style={{ padding: '20px 24px', borderBottom: '1px solid #E2E2E6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ margin: 0 }}>{editTask ? 'Modifier la tache' : 'Ajouter une tache'}</h3>
        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer' }}><X size={24} /></button>
      </div>
      <form onSubmit={onSubmit} style={{ padding: '24px' }}>
        {editTask ? (
          <div className="form-group">
            <label className="form-label">Employe *</label>
            <Select value={formData.user_id} onValueChange={(v) => setFormData({ ...formData, user_id: v })}>
              <SelectTrigger data-testid="task-employee-select"><SelectValue placeholder="Selectionner un employe" /></SelectTrigger>
              <SelectContent className="z-[9999]">
                {employees.map((emp) => (
                  <SelectItem key={emp.id} value={emp.id}>{emp.name} - {emp.job_title || 'Non defini'}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        ) : (
          <div className="form-group">
            <label className="form-label">Salaries * ({(formData.user_ids || []).length} selectionne(s))</label>
            <div style={{ maxHeight: '180px', overflowY: 'auto', border: '1px solid #E2E2E6', borderRadius: '6px', padding: '6px' }} data-testid="task-employees-checklist">
              {employees.map(emp => {
                const ids = formData.user_ids || [];
                const checked = ids.includes(emp.id);
                return (
                  <label key={emp.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 8px', borderRadius: '4px', cursor: 'pointer', backgroundColor: checked ? '#E8F0FE' : 'transparent' }}>
                    <input
                      type="checkbox"
                      checked={checked}
                      onChange={() => {
                        const next = checked ? ids.filter(i => i !== emp.id) : [...ids, emp.id];
                        setFormData({ ...formData, user_ids: next, user_id: next[0] || '' });
                      }}
                      data-testid={`task-employee-cb-${emp.id}`}
                      style={{ accentColor: '#002FA7', width: '16px', height: '16px' }}
                    />
                    <span style={{ fontSize: '0.9rem' }}>{emp.name} <span style={{ color: '#9E9EA7', fontSize: '0.8rem' }}>- {emp.job_title || 'Non defini'}</span></span>
                  </label>
                );
              })}
            </div>
          </div>
        )}
        
        {editTask ? (
          <div className="form-group">
            <label className="form-label">Date *</label>
            <input data-testid="task-date-input" type="date" className="form-input" value={formData.date} onChange={(e) => setFormData({ ...formData, date: e.target.value })} required />
          </div>
        ) : (
          <>
            <div className="form-group">
              <label className="form-label">Mode de date</label>
              <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                {[
                  { k: 'single', label: 'Un jour' },
                  { k: 'range', label: 'Plage de dates' },
                ].map(m => (
                  <button key={m.k} type="button" onClick={() => setFormData({ ...formData, date_mode: m.k })} data-testid={`task-mode-${m.k}`}
                    style={{ padding: '5px 14px', borderRadius: '14px', border: 'none', fontSize: '0.82rem', fontWeight: '600', cursor: 'pointer', backgroundColor: (formData.date_mode || 'single') === m.k ? '#002FA7' : '#F4F5F7', color: (formData.date_mode || 'single') === m.k ? 'white' : '#5E5F66' }}>
                    {m.label}
                  </button>
                ))}
              </div>
            </div>
            {(formData.date_mode || 'single') === 'single' ? (
              <div className="form-group">
                <label className="form-label">Date *</label>
                <input data-testid="task-date-input" type="date" className="form-input" value={formData.date} onChange={(e) => setFormData({ ...formData, date: e.target.value })} required />
              </div>
            ) : (
              <>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  <div className="form-group">
                    <label className="form-label">Date debut *</label>
                    <input data-testid="task-start-date" type="date" className="form-input" value={formData.start_date || ''} onChange={(e) => setFormData({ ...formData, start_date: e.target.value })} required />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Date fin *</label>
                    <input data-testid="task-end-date" type="date" className="form-input" value={formData.end_date || ''} onChange={(e) => setFormData({ ...formData, end_date: e.target.value })} required />
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label" style={{ fontSize: '0.82rem' }}>Jours de la semaine (vide = tous les jours)</label>
                  <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                    {[{ n: 0, l: 'Lun' }, { n: 1, l: 'Mar' }, { n: 2, l: 'Mer' }, { n: 3, l: 'Jeu' }, { n: 4, l: 'Ven' }, { n: 5, l: 'Sam' }, { n: 6, l: 'Dim' }].map(d => {
                      const wds = formData.weekdays || [];
                      const on = wds.includes(d.n);
                      return (
                        <button key={d.n} type="button" onClick={() => {
                          const next = on ? wds.filter(x => x !== d.n) : [...wds, d.n];
                          setFormData({ ...formData, weekdays: next });
                        }} data-testid={`task-wd-${d.n}`}
                          style={{ padding: '5px 10px', borderRadius: '6px', border: `1px solid ${on ? '#002FA7' : '#E2E2E6'}`, fontSize: '0.78rem', fontWeight: '600', cursor: 'pointer', backgroundColor: on ? '#002FA7' : 'white', color: on ? 'white' : '#5E5F66' }}>
                          {d.l}
                        </button>
                      );
                    })}
                    <button type="button" onClick={() => setFormData({ ...formData, weekdays: [0, 1, 2, 3, 4] })} data-testid="task-wd-preset-mf" style={{ padding: '5px 10px', borderRadius: '6px', border: '1px dashed #5E5F66', fontSize: '0.78rem', fontWeight: '600', cursor: 'pointer', backgroundColor: '#F4F5F7', color: '#5E5F66' }}>
                      Lun-Ven
                    </button>
                  </div>
                </div>
              </>
            )}
          </>
        )}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
          <div className="form-group">
            <label className="form-label">Heure debut *</label>
            <input data-testid="task-start-time" type="time" className="form-input" value={formData.start_time} onChange={(e) => setFormData({ ...formData, start_time: e.target.value })} required />
          </div>
          <div className="form-group">
            <label className="form-label">Heure fin *</label>
            <input data-testid="task-end-time" type="time" className="form-input" value={formData.end_time} onChange={(e) => setFormData({ ...formData, end_time: e.target.value })} required />
          </div>
        </div>
        <div className="form-group">
          <label className="form-label">Titre / Chantier *</label>
          {freeTextMode ? (
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <input
                data-testid="task-title-input"
                type="text"
                className="form-input"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                placeholder="Saisir un titre librement"
                required
                autoFocus
                style={{ flex: 1 }}
              />
              <button type="button" className="btn btn-secondary btn-sm" onClick={() => { setFreeTextMode(false); setFormData({ ...formData, title: '' }); }} title="Choisir un chantier">
                <X size={14} />
              </button>
            </div>
          ) : (
            <>
              <Select value={formData.title || undefined} onValueChange={handleSelectTitle}>
                <SelectTrigger data-testid="task-title-select"><SelectValue placeholder="Selectionner un chantier ou saisir librement" /></SelectTrigger>
                <SelectContent className="z-[9999]">
                  {projects.map((p) => (<SelectItem key={p.id} value={p.name}>{p.name} {p.client_name ? `- ${p.client_name}` : ''}</SelectItem>))}
                  <SelectItem value="__custom__"><PencilSimple size={14} style={{ marginRight: '6px', verticalAlign: 'middle' }} />Saisie libre...</SelectItem>
                </SelectContent>
              </Select>
              {!formData.title && <p style={{ margin: '4px 0 0', fontSize: '0.75rem', color: '#5E5F66' }}>Selectionnez un chantier ou cliquez "Saisie libre"</p>}
            </>
          )}
        </div>
        <div className="form-group">
          <label className="form-label"><MapPin size={14} style={{ marginRight: '6px', verticalAlign: 'middle' }} />Adresse du chantier</label>
          <AddressAutocomplete
            value={formData.address}
            onChange={(val, geo) => {
              const updates = { ...formData, address: val };
              if (geo) { updates.latitude = geo.lat; updates.longitude = geo.lon; }
              setFormData(updates);
            }}
            placeholder="Rechercher une adresse..."
            data-testid="task-address-input"
          />
          <p style={{ fontSize: '0.7rem', color: '#5E5F66', marginTop: '4px' }}>Cette adresse sera utilisee pour guider l'employe vers le chantier</p>
        </div>
        <div className="form-group">
          <label className="form-label">Description (optionnel)</label>
          <textarea data-testid="task-description-input" className="form-input" value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} rows={2} placeholder="Instructions supplementaires..." />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <div className="form-group">
            <label className="form-label">Couleur</label>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
              {['#1565C0','#0EA5E9','#10B981','#F59E0B','#DC2626','#7C3AED','#EC4899','#6B7280'].map(c => (
                <button key={c} type="button" data-testid={`task-color-${c}`} onClick={() => setFormData({ ...formData, color: c })} style={{ width: 26, height: 26, borderRadius: '50%', border: (formData.color || '#1565C0') === c ? '3px solid #202124' : '2px solid #E2E2E6', backgroundColor: c, cursor: 'pointer' }} aria-label={`couleur ${c}`} />
              ))}
              <input type="color" data-testid="task-color-custom" value={formData.color || '#1565C0'} onChange={(e) => setFormData({ ...formData, color: e.target.value })} style={{ width: 32, height: 32, border: 'none', background: 'transparent', cursor: 'pointer' }} />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Priorite</label>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {[{k:'low',l:'Basse',c:'#9CA3AF'},{k:'normal',l:'Normale',c:'#1565C0'},{k:'high',l:'Haute',c:'#F59E0B'},{k:'urgent',l:'Urgente',c:'#DC2626'}].map(p => {
                const on = (formData.priority || 'normal') === p.k;
                return (
                  <button key={p.k} type="button" data-testid={`task-priority-${p.k}`} onClick={() => setFormData({ ...formData, priority: p.k })} style={{ padding: '6px 12px', borderRadius: 999, border: `1px solid ${on ? p.c : '#E2E2E6'}`, backgroundColor: on ? p.c : 'white', color: on ? 'white' : '#5E5F66', fontSize: '0.78rem', fontWeight: 700, cursor: 'pointer' }}>{p.l}</button>
                );
              })}
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '12px', marginTop: '24px', flexWrap: 'wrap' }}>
          {editTask && !confirmDelete && (
            <button type="button" data-testid="delete-task-btn" className="btn btn-danger" onClick={() => setConfirmDelete(true)}>
              <Trash size={16} /> Supprimer
            </button>
          )}
          {!confirmDelete && (
            <>
              <button type="button" className="btn btn-secondary" onClick={onClose} style={{ flex: 1 }}>Annuler</button>
              <button type="submit" data-testid="submit-task-btn" className="btn btn-primary" style={{ flex: 1 }}>{editTask ? 'Enregistrer' : 'Ajouter'}</button>
            </>
          )}
          {editTask && confirmDelete && (
            <div data-testid="delete-confirm-panel" style={{ width: '100%', padding: '12px', backgroundColor: '#FEECEB', border: '1px solid #F5B7B1', borderRadius: '4px' }}>
              <p style={{ margin: '0 0 12px 0', fontSize: '0.9rem', fontWeight: '600', color: '#922B21' }}>
                Confirmer la suppression ?
              </p>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                <button type="button" data-testid="confirm-delete-one-btn" className="btn btn-danger" style={{ flex: 1, minWidth: '140px' }} onClick={() => { onDelete(editTask.id); }}>
                  <Trash size={14} /> {hasSeries ? 'Cette occurrence' : 'Supprimer'}
                </button>
                {hasSeries && onDeleteSeries && (
                  <button type="button" data-testid="confirm-delete-series-btn" className="btn btn-danger" style={{ flex: 1, minWidth: '140px', backgroundColor: '#922B21' }} onClick={() => { onDeleteSeries(editTask.recurrence_group); }}>
                    <Trash size={14} /> Toute la serie
                  </button>
                )}
                <button type="button" className="btn btn-secondary" style={{ flex: 1, minWidth: '90px' }} onClick={() => setConfirmDelete(false)}>Annuler</button>
              </div>
            </div>
          )}
        </div>
      </form>
    </div>
  </div>
  );
};
